module.exports = __webpack_public_path__ + "static/media/shapes_17.deadda0d.svg";